import * as React from "react";
const SvgEllipse = (props) => /* @__PURE__ */ React.createElement("svg", { width: "1em", height: "1em", viewBox: "0 0 12 12", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("circle", { id: "Ellipse 5", cx: 6, cy: 6, r: 4.5, fill: "white", stroke: "#D9D9D9", strokeWidth: 3 }));
export default SvgEllipse;
